import React from 'react';

const PackageFeatureItem = ({ feature }) => {
    let { title, subtitle } = feature;
    return (
        <li className="title">
            { title }
            <ul className="subtitle-list">
            {
                subtitle.map((item, index) => {
                    return <li key={index}> - {item}</li>
                })
            }
            </ul>
        </li>
    );
}

export default PackageFeatureItem;